import requestMaker from 'lib';

export const getEnvironment = () => {
  const url = `/proxy/cust/px/ge`;
  return requestMaker(url);
};

export const encryptData = data => {
  const baseQuery = `/proxy/cust/px/ce`;
  const params = {};
  const payload = { text: data };
  return requestMaker(baseQuery, { params, payload });
};

export const decryptData = data => {
  const baseQuery = `/proxy/cust/px/cd`;
  const params = {};
  const payload = { text: data };
  return requestMaker(baseQuery, { params, payload });
};

export const saveUserInfo = data => {
  const baseQuery = `/proxy/cust/px/sui`;
  const params = {};
  const payload = { userInfo: data };
  return requestMaker(baseQuery, { params, payload });
};

export const clearCookies = () => {
  const baseQuery = `/proxy/cust/px/cc`;
  const params = {};
  const payload = {};
  return requestMaker(baseQuery, { params, payload });
};
